<template>
  <v-row justify="center">
    <v-dialog
      v-model="toggleModal"
      persistent
      :max-width="options.width"
      :style="{zIndex: options.zIndex}"
      @keydown.esc="cancelModalAction"
      @click:outside="cancelModalAction"
    >
      <v-card
        class="pa-16"
        :min-height="options.minHeight"
      >
        <div v-if="options.icon">
          <span class="icon-hero">
            <v-icon
              class="ma-auto"
              color="primary"
              size="36"
            >
              {{ options.icon }}
            </v-icon>
          </span>
        </div>
        <v-card-title
          v-if="options.title"
          class="text-h5 modal-title"
        >
          {{ options.title }}
        </v-card-title>
        <v-card-text
          v-if="options.text"
          id="modal-body-text"
          class="text-center"
          v-html="options.text"
        />
        <div
          class="btn-container"
        >
          <div class="align-actions">
            <v-btn
              :color="options.confirmColor"
              @click.native="confirmModalAction"
            >
              {{ options.confirmText }}
            </v-btn>
            <v-btn
              color="secondary"
              @click.native="cancelModalAction"
            >
              {{ options.cancelText }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'BaseModal',
    data: () => {
      return {
        toggleModal: false,
        resolved: null,
        reject: null,
        options: {
          text: null,
          title: null,
          icon: null,
          cancelText: 'cancel',
          confirmText: 'confirm',
          confirmColor: 'error',
          color: 'primary',
          width: 290,
          minHeight: 300,
          zIndex: 900,
          modalType: String,
        },
      }
    },
    methods: {
      open (options) {
        this.toggleModal = true
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolved = resolve
          this.reject = reject
        })
      },
      close () {
        this.toggleModal = false
        this.options = {
          text: null,
          title: null,
          icon: null,
          cancelText: 'cancel',
          confirmText: 'confirm',
          confirmColor: 'error',
          color: 'primary',
          width: 290,
          minHeight: 300,
          zIndex: 900,
        }
      },
      cancelModalAction () {
        this.reject(true)
        this.close()
      },
      confirmModalAction () {
        this.resolved(true)
        this.close()
      },
    },
  }
</script>
<style lang="scss" scoped>
 .icon-hero {
    display: flex;
    background-color: $secondary;
    border-radius: 100px;
    text-align: center;
    width: 83px;
    height: 83px;
    padding: 15px;
    margin: 9px auto 2px auto;
  }
  .btn-container {
    display: flex;
    button {
      min-width: 175px !important;
    }
  }
  .align-actions {
    display: inline-block;
    margin: 3px auto 0 auto;
    padding: 15px 8px 8px 8px;
    text-align: center;
    & > button + button {
        margin: 17px 0 0 0;
      }
  }
  .modal-title {
    line-height: 31px;
    color: #{$base};
    word-break: normal;
  }
  #modal-body-text {
    line-height: 20px;
    padding: 17px 0 20px 0;
    color: #2B394e;
  }
</style>
